module.exports = __webpack_public_path__ + "img/star.4ec5e443.svg";